import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import ErrorNoResultHeader from './errorNoResultHeader';
import $ from "jquery";
import Footer from './Footer';
import * as requestLib from '../lib/requestLib'
import Header from '../pages/header';

export default class Error504 extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };

        this.baseUrl = requestLib.getUrl();

    }
    componentWillMount() {
        $('footer').css('position', 'fixed');
    }
    render() {
        return (
            <div id="mainContainer" className="errormsg">
                {/* <ErrorNoResultHeader/> */}
                <Header list={[]} groupList={this.props.groupList} noResult={true} />
                <div className="noResult">
                    <div className="wrapB">
                        <h2>Oh, my darwin! An error has occurred.</h2>
                        <p>This is an embrassing moment, but it seems like there is something</p>
                        <p>wrong with our database. You may choose different keywords or</p>
                        <p>you may try to  <a href={this.baseUrl + 'search'}>search again</a> as well.</p>

                    </div>
                </div>
                <Footer posinone={true} />
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/Error504.js